export default __webpack_public_path__ + "static/media/Slider_3500_Mobile.0c5e77b2.png";